<template>
  <tr wrap v-if="stock">
    <slot></slot>
    <td
      class="px-2 py-1 form-control"
      style="border-right: 1px solid #eee;min-width: 100px"
      :class="{ 'has-error': errors.has('quantity_' + index + '_' + oindex) }"
    >
      <v-tooltip :value="errors.has('quantity_' + index + '_' + oindex)" top color="error">
        <template v-slot:activator="{ on }">
          <input
            type="text"
            :name="'quantity_' + index + '_' + oindex"
            :data-vv-name="'quantity_' + index + '_' + oindex"
            :data-vv-as="$t('quantity')"
            v-validate="'required|numeric'"
            maxlength="4"
            pattern="[0-9]*"
            inputmode="numeric"
            class="form-control mb-0"
            :id="'quantityInput' + index + '_' + oindex"
            :placeholder="$t('quantity')"
            v-model="stock[2]"
            @blur="$set(stock, 2, numberOnly($event))"
          />
        </template>
        <span v-if="errors.has('quantity_' + index + '_' + oindex)">{{
          errors.first('quantity_' + index + '_' + oindex)
        }}</span>
      </v-tooltip>
    </td>
    <td
      class="px-2 py-1 form-control"
      style="border-right: 1px solid #eee;min-width: 100px"
      :class="{ 'has-error': errors.has('price_' + index + '_' + oindex) }"
    >
      <v-tooltip :value="errors.has('price_' + index + '_' + oindex)" top color="error">
        <template v-slot:activator="{ on }">
          <input
            type="text"
            :name="'price_' + index + '_' + oindex"
            :data-vv-name="'price_' + index + '_' + oindex"
            :data-vv-as="$t('Price')"
            v-validate="'decimal:2|min_value:1'"
            pattern="[0-9]*"
            maxlength="13"
            inputmode="numeric"
            class="form-control mb-0"
            :id="'priceInput' + index + '_' + oindex"
            :placeholder="$t('Price') + '(Optional)'"
            @blur="
              $set(stock, 3, decimalOnly($event))
              onBlurPrice($event)
            "
            v-model="stock[3]"
          />
        </template>
        <span v-if="errors.has('price_' + index + '_' + oindex)">{{
          errors.first('price_' + index + '_' + oindex)
        }}</span>
      </v-tooltip>
    </td>
    <td
      class="px-2 py-1 form-control"
      style="border-right: 1px solid #eee;min-width: 100px"
      :class="{ 'has-error': errors.has('saleprice_' + index + '_' + oindex) }"
    >
      <v-tooltip :value="errors.has('saleprice_' + index + '_' + oindex)" top color="error">
        <template v-slot:activator="{ on }">
          <input
            type="text"
            :name="'saleprice_' + index + '_' + oindex"
            :data-vv-name="'saleprice_' + index + '_' + oindex"
            :data-vv-as="$t('Sale price')"
            v-validate="'decimal:2|min_value:1|isLessThanOrEqual:' + stock[3]"
            pattern="[0-9]*"
            maxlength="13"
            inputmode="numeric"
            class="form-control mb-0"
            :id="'salepriceInput' + index + '_' + oindex"
            :placeholder="$t('Sale price') + '(Optional)'"
            v-model="stock[4]"
            @blur="$set(stock, 4, decimalOnly($event))"
          />
        </template>
        <span v-if="errors.has('saleprice_' + index + '_' + oindex)">{{
          errors.first('saleprice_' + index + '_' + oindex)
        }}</span>
      </v-tooltip>
    </td>
    <td
      class="px-2 py-1 form-control"
      style="border-right: 1px solid #eee;min-width: 100px"
      :class="{ 'has-error': errors.has('sku_' + index + '_' + oindex) }"
    >
      <v-tooltip :value="errors.has('sku_' + index + '_' + oindex)" top color="error">
        <template v-slot:activator="{ on }">
          <input
            type="text"
            :name="'sku_' + index + '_' + oindex"
            :data-vv-name="'sku_' + index + '_' + oindex"
            :data-vv-as="$t('SKU') + ' (Optional)'"
            class="form-control mb-0"
            :id="'skuInput' + index + '_' + oindex"
            :placeholder="$t('SKU') + ' (Optional)'"
            v-model="stock[5]"
          />
        </template>
        <span v-if="errors.has('sku_' + index + '_' + oindex)">{{
          errors.first('sku_' + index + '_' + oindex)
        }}</span>
      </v-tooltip>
    </td>
  </tr>
</template>

<script>
export default {
  inject: ['$validator'],
  props: ['value', 'index', 'oindex', 'category', 'option'],
  data() {
    return {
      key: `${this.category}${this.option ? `/${this.option}` : ''}`,
      stock: null
    }
  },
  mounted() {
    this.stock = this.value ? this.value : [null, this.key, null, null, null, null, 0, null]
  },
  methods: {
    onBlurPrice: function() {
      this.$set(this.stock, 4, this.stock[3])
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/ProductStockItem2.vue